import {
  Landmark,
  Paperclip,
  Text,
  User,
  Users,
  MapPinned,
  FileText,
  CircleCheckBig,
  TextSearch,
} from "lucide-react";
import {
  ConditionSeparator,
  ContactDetail,
  ContractHeader,
  Detail,
} from "./ContractDetails";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toPascalCase } from "../../utils/helpers";
import { FaCity, FaGavel } from "react-icons/fa";
import { FaFlagUsa } from "react-icons/fa";
import { Attachments } from "./Attachments";
import { Separator } from "../../components/ui/separator";
import { ContractContext } from "./ContractDescription";
import { useContext } from "react";
import { Recommendations } from "./Recommendations";
import Subcontractors from "./Subcontractors";


export default function SLEDContract({ contract }) {
  const {
    level = null,
    jurisdiction = null,
    state = null,
    description: desc = null,
    dueDate = null,
    startDate = null,
    closeDate = null,
    publishedDate = null,
    lastUpdatedDate = null,
    type = null,
    agency = null,
    status = null,
    location = null,
    attachments = [],
    contactInfo = [],
  } = contract || {};

  const { isLoading } = useContext(ContractContext);

  const headerData = [
    {
      title: "Buyer",
      icon: Landmark,
      details: [toPascalCase(agency)],
    },
    {
      title: "Level",
      icon: FaCity,
      details: [toPascalCase(level)],
    },
    {
      title: "State",
      icon: FaFlagUsa,
      details: [toPascalCase(state)],
    },
    {
      title: "Jurisdiction",
      icon: FaGavel,
      details: [toPascalCase(jurisdiction)],
    },
  ];

  const timelineData = [
    {
      title: "Post Date",
      date: startDate,
    },
    {
      title: "Publish Date",
      date: publishedDate,
    },
    {
      title: "Last Updated",
      date: lastUpdatedDate,
    },
    {
      title: "Due Date",
      date: dueDate,
    },
    {
      title: "Close Date",
      date: closeDate,
    },
  ];

  return (
    <dl>
      <div id="contract-details" className="flex flex-col gap-4 py-4 ">
        <ContractHeader headerData={headerData} timelineData={timelineData} />

        {ConditionSeparator(isLoading, type, status, location)}
        <Detail title="Type" icon={FileText} details={[type]} />
        <Detail
          title="Status"
          icon={CircleCheckBig}
          details={[toPascalCase(status)]}
        />
        <Detail
          title="Location"
          icon={MapPinned}
          details={[toPascalCase(location)]}
        />
        {ConditionSeparator(
          isLoading,
          contactInfo[0]?.name,
          contactInfo[0]?.email,
          contactInfo[0]?.phone,
          contactInfo[1]?.name,
          contactInfo[1]?.email,
          contactInfo[1]?.phone
        )}
        <ContactDetail
          title="Primary Contact"
          icon={User}
          fullname={contactInfo[0]?.name}
          email={contactInfo[0]?.email}
          phone={contactInfo[0]?.phone}
        />
        <ContactDetail
          title="Secondary Contact"
          icon={Users}
          fullname={contactInfo[1]?.name}
          email={contactInfo[1]?.email}
          phone={contactInfo[1]?.phone}
        />
        {ConditionSeparator(isLoading, desc)}
        <div id="contract-description">
          <Detail title="Description" icon={Text} details={[desc]} />
        </div>
        <Separator />
        <Detail
          title="Attachments"
          icon={Paperclip}
          details={[
            <Attachments
              attachments={attachments}
              searchType="sled"
              isLoading={isLoading}
            />,
          ]}
        />
        <Separator />

              <Tabs
        defaultValue="similar"
        className="w-full"
        id="contract-recommendations"
      >
        <div className="min-w-10/12 mx-auto">
          <TabsList className="flex justify-center gap-12 mb-4">
            <TabsTrigger value="similar">🔍 Similar Opportunities</TabsTrigger>
            <TabsTrigger value="subcontractors">💼 Subcontractors</TabsTrigger>
          </TabsList>
        </div>
      
        <TabsContent value="subcontractors">
          <Detail
            title="💼 Potential Subcontractors"
            details={
              [
              <Subcontractors
                naics=""
                description={desc}
                streetAddress={location}
                city=""
                state={state}
                zip=""
                country=""
              />,
            ]}
          />
        </TabsContent>
      </Tabs>

      </div>
    </dl>
  );
}
